
/* injects from baggage-loader */

export const dialogos = [
[

["Olá, <strong>", "</strong>! Sou o guardião Matemágico, protetor da Montanha da Paz. Você foi escolhido para salvar a <strong>Ilha das Operações</strong> do desastre final."],
"Sua missão será reunir as <strong>Pedras Fundamentais</strong> na montanha para restaurar a paz na ilha. Cumpra os desafios, encontre as pedras e salve a <strong>Ilha das Operações</strong>!" ,
"Vamos começar!"],
["Muito bem, você conseguiu resolver o primeiro desafio. Com isso, você ganhou a localização da <strong>Pedra do Oeste</strong>. Continue ajudando para obtê-la." ,
"Pronto para o próximo desafio na ilha do oeste?" ],
["Muito bem! Você conseguiu resolver o <strong>segundo desafio</strong>. Com isso, você conquistou a <strong>Pedra Multiplis</strong>.<br>Que tal levar ajuda para o Povo do Leste?" ],
["Isso mesmo! Você conseguiu resolver o <strong>terceiro desafio</strong>. Agora você encontrou a localização da <strong>Pedra Divisarions</strong>.",
"Resolva a próxima situação e conquiste a pedra!"],
["Muito bem! Agora que você conseguiu resolver o quarto desafio, adquiriu, além da Pedra <strong>Multiplis</strong>, a Pedra <strong>Divisarions</strong>." ],
["<strong>Muito bem</strong>! Agora que você possui todas as pedras, precisará reuni-las na <strong>Montanha da Paz</strong> para que nossa ilha regenere-se."],
];

export const briefing = [
{items: ['fruta', 'aldeao'], text: 'Ajude na colheita de frutas! Para isto, estarão disponíveis <strong>frutas</strong> e <strong>aldeões</strong>.'},
{items: ['caixote', 'caixa', 'fruta'], text: 'Ajude os aldeões na colheita de frutas! Para isto, estão disponíveis <strong>caixotes</strong>, <strong>caixas</strong> e <strong>frutas</strong>.'},
{items: ['cavalo', 'cercado'], text: 'Ajude os aldeões na ilha do povo do leste. Para isto, estarão disponíveis <strong>cavalos</strong> e <strong>cercados</strong>.'},
{items: ['caixote', 'fruta'], text: 'Ajude os aldeões na ilha do povo do leste. Para isto, estarão disponíveis <strong>caixotes</strong> e <strong>frutas</strong>.'},
{items: ['cavalo', 'fruta'], text: 'Ajude os aldeões na ilha do povo do leste. Para isto, estarão disponíveis <strong>cavalos</strong> e <strong>frutas</strong>.'},
];


// WEBPACK FOOTER //
// ./src/app/pages/main/main.const.js